$(window).on("load",function(){
    $("html").removeClass("preload");
});
$(function(){

    var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/strait-up/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		$('body').prepend(svg);
	});

    //ページ内スクロール
    $.smooziee();

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

    //メニュー名以外の部分をクリックで閉じる
    $('.layer').on('click', function () {
        body.removeClass('menu_open');
        // body.removeClass('search_open');
    });

    //スクロールしたらクラスを付与
    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            body.addClass('scroll');
        } else {
            body.removeClass('scroll');
        }
    });

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

    //ニューウィンドウ表示
    $('.btn_popup').on('click', function () {
        window.open(this.href, '', 'width=800, height='+screen.availHeight+', scrollbars=yes');
        return false;
    });

    //検索BOX
    var menuBtn = $('.search_btn');
    var closeBtn = $('.search_close');
    var wrapper = $('body');
    var layer = $('.layer');
    $(menuBtn).on('click', function(e) {
        if($(this).is('.search_open')) {
            $(this).add(wrapper).removeClass('search_open');
            layer.removeClass('on');
        } else {
            $(this).add(wrapper).addClass('search_open');
            layer.addClass('on');
        }
        e.preventDefault();
    });
    layer.on('click' , function(e) {
        $(menuBtn).add(wrapper).removeClass('search_open');
        $(layer).removeClass('on');
        e.preventDefault();
    });
    closeBtn.on('click' , function(e) {
        $(menuBtn).add(wrapper).removeClass('search_open');
        $(layer).removeClass('on');
        e.preventDefault();
    });

    //検索アコーディオン
    $(".kensaku").on('click', function() {
        $(this).toggleClass("on");
        $(".kensaku_block").slideToggle();
    });

    //タイマー設定
    $(".view_timer").each(function(index, target) {
        var startDate = $(this).attr("data-start-date");
        var endDate = $(this).attr("data-end-date");
        var nowDate = new Date();
        if (startDate) {
            startDate = new Date(startDate);
        } else {
            startDate = nowDate;
        }
        if (endDate) {
            endDate = new Date(endDate);
        }
        if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

	//言語切り替え
	$('.header_language_trigger').on('click', function () {
		$(this).toggleClass('on');
		$(this).parents(".header_language").toggleClass('on');
		$(this).next(".header_language_content").toggleClass('on');
		$(".header_language_trigger").not(this).removeClass("on");
		$(".header_language_trigger").not(this).parents(".header_language").removeClass("on");
		$(".header_language_trigger").not(this).next().removeClass("on");
		$(".header_language_trigger").not(this).next().slideUp(300);
		$(this).next().slideToggle(300);
	}); 

    /*--------------------------------------------------
    サイズによる動的切り替え
    --------------------------------------------------*/
    function checkScreenSize() {
        var width = $(window).width();
        if (width < 768) {
            // スマホの処理
            // 高さ揃え（選ばれる理由）
            $('.home_reason_list .ttl').tile(2);
        } else {
            // PCの処理
            // 高さ揃え（選ばれる理由）
            $('.home_reason_list .ttl').tile(4);
        }
    }

    // ページ読み込み時
    $(document).ready(function() {
        checkScreenSize();
    });

    // ウィンドウサイズ変更時
    $(window).resize(function() {
        checkScreenSize();
    });

    /*--------------------------------------------------
    スマホのみ
    --------------------------------------------------*/
    $(function() {
        if (!isPhone())
            return;

        //ドロップメニュー
        $(".header_nav_main_drop_trigger").on("click", function(event) {
            $(this).toggleClass('open');
            $(this).next().slideToggle();
            event.preventDefault();
        });

    });

    /*--------------------------------------------------
    PCのみ
    --------------------------------------------------*/
    $(function() {
        if (isPhone())
            return;

        $(window).scroll(function () {
            if ($(this).scrollTop() > 300) {
                //スクロールが300に達したらボタン表示
            } else {
            }
        });

    });

    function isPhone() {
        return (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0);
    }

    /*--------------------------------------------------
    ニュースティッカー
    --------------------------------------------------*/
    const swiperTicker = new Swiper('.swiper-ticker', {
        // 基本設定
        direction: 'vertical', // 縦方向のスクロール
        loop: true,
        // slidesPerView: 1, // または数値で表示件数指定（例：3）
        // spaceBetween: 10, // スライド間の余白
        // 自動再生設定
        autoplay: {
            delay: 3000, // 3秒間隔で次のスライドへ
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        // スピード設定（スライド切り替えの速度）
        speed: 800,
        // 縦ティッカー用の設定
        grabCursor: false,
        allowTouchMove: false, // タッチ操作無効
        // 高さの設定（CSSでも可能）
        // height: 50, // ティッカーの高さ
        // ブレークポイント対応
        // breakpoints: {
        //     769: {
        //         direction: 'vertical',
        //     }
        // }
    });

    /*--------------------------------------------------
    FVスライダー
    --------------------------------------------------*/
    const swiperFv = new Swiper('.swiper-fv', {
        loop: true,
        // 自動再生
        autoplay: {
            delay: 3000, // 間隔
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
    });

    /*--------------------------------------------------
    車両詳細サブメニュー スクロール位置変更
    --------------------------------------------------*/
    if($('.car_nav').length){
        const activePosition = $(".car_nav .active").position().left;
        const containerWidth = $(".car_nav").width();
        // アクティブ要素が画面の右半分にある場合のみスクロール
        if(activePosition > containerWidth / 2) {
            const headerNavBox = $(".car_nav");
            const scrollPosition = activePosition - (containerWidth / 3); // 1/3の位置に配置
            headerNavBox.delay(1000).animate({
                scrollLeft: Math.max(0, scrollPosition)
            });
        }
    }

    /*--------------------------------------------------
    車両詳細スライドショー
    --------------------------------------------------*/
    // jQueryのスコープから一時的に抜ける
    setTimeout(function() {
        // 純粋なJavaScriptスコープで実行
        (function() {
            const thumbnails = document.querySelectorAll('.swiper-car-thumbnail');
            const mains = document.querySelectorAll('.swiper-car');
            console.log('サムネイル数:', thumbnails.length, 'メイン数:', mains.length); 
            thumbnails.forEach(function(thumbnailEl, i) {
                const mainEl = mains[i];
                if (thumbnailEl && mainEl && !thumbnailEl.swiper) {
                    try {
                        // サムネイル初期化
                        const thumbSwiper = new Swiper(thumbnailEl, {
                            slidesPerView: "auto",
                            freeMode: true,
                            watchSlidesVisibility: true,
                            watchSlidesProgress: true,
                        });
                        
                        // メイン初期化
                        const mainSwiper = new Swiper(mainEl, {
                            slidesPerView: 1,
                            thumbs: {
                                swiper: thumbSwiper,
                            },
                        });
                        console.log('スライダー', i, '初期化完了');
                    } catch (error) {
                        console.error('スライダーエラー:', error);
                    }
                }
            });
        })();
    }, 200); // 200ms遅延でjQueryの初期化完了を待つ

    /*--------------------------------------------------
    よくあるご質問アコーディオン
    --------------------------------------------------*/ 
	$('.faqList .ttl').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".txts").slideToggle();
	});  

    /*--------------------------------------------------
    トップページのみ
    --------------------------------------------------*/
    if($('.home').length){
        /*--------------------------------------------------
        車一覧
        --------------------------------------------------*/
        var swiperLineup = null;
        function initSwiper() {
            // スマホサイズ（768px以下）の場合のみSwiperを初期化
            if ($(window).width() <= 768 && swiperLineup === null) {
                swiperLineup = new Swiper('.swiper-lineup', {
                    // loop: true,
                    slidesPerView: "auto", // または数値で表示件数指定（例：3）
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                });
            }
            // PC・タブレットサイズの場合はSwiperを破棄
            else if ($(window).width() > 768 && swiperLineup !== null) {
                swiperLineup.destroy(true, true);
                swiperLineup = null;
            }
        }
        // 初期化実行
        initSwiper();
        // リサイズ時に再評価
        $(window).resize(function() {
            initSwiper();
        });
    }

    /*--------------------------------------------------
    中古車販売スライダー
    --------------------------------------------------*/
    var usedCarSwiperInstance = null;
    function initUsedCarSwiper() {
        if (!$('.used-car-swiper').length) return;
        if (window.innerWidth <= 768) {
            if (!usedCarSwiperInstance) {
                // スライドを複製してループを安定させる
                var $wrapper = $('.used-car-swiper .swiper-wrapper');
                var $clones = $wrapper.children(':not(.is-clone)').clone().addClass('is-clone');
                $wrapper.append($clones);

                usedCarSwiperInstance = new Swiper('.used-car-swiper', {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.used-car-swiper .swiper-button-next',
                        prevEl: '.used-car-swiper .swiper-button-prev',
                    },
                });
            }
        } else {
            if (usedCarSwiperInstance) {
                usedCarSwiperInstance.destroy(true, true);
                usedCarSwiperInstance = null;
                // 複製したスライドを削除
                $('.used-car-swiper .swiper-slide.is-clone').remove();
            }
        }
    }
    initUsedCarSwiper();
    $(window).on('resize', initUsedCarSwiper);

});

$(function() {
    $.datepicker.setDefaults($.datepicker.regional["ja"]);

    var minDate = new Date();
    minDate.setDate(minDate.getDate() + 2); // 明後日

    var maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 3); // 3ヶ月後

    $("#date_departure").datepicker({
        dateFormat: "yy-mm-dd",
        minDate: minDate,
        maxDate: maxDate,
         beforeShowDay: function(date) {
            if (date.getDay() === 1) {
                return [false, "", "月曜日は選択できません"];
            }
            return [true, "", ""];
        },
        onSelect: function(dateText) {
        $(this).validationEngine('validate');
        $("#date_return").datepicker("option", "minDate", new Date(dateText));
        var returnDate = $("#date_return").datepicker("getDate");
        if (returnDate && returnDate < new Date(dateText)) {
        $("#date_return").datepicker("setDate", null);
        }
    }
    });

    var sessionDeparture = "<?php echo isset($_SESSION['date_departure']) ? $_SESSION['date_departure'] : ''; ?>";
    var returnMin = sessionDeparture ? new Date(sessionDeparture) : minDate;

    $("#date_return").datepicker({
    dateFormat: "yy-mm-dd",
    minDate: returnMin,
    maxDate: maxDate,
    beforeShowDay: function(date) {
        if (date.getDay() === 1) {
        return [false, "", "月曜日は選択できません"];
        }
        return [true, "", ""];
    },
    onSelect: function(dateText) {
        $(this).validationEngine('validate');
    }
    });

    $(".validation").validationEngine('attach', {
    promptPosition: "topLeft"
    });

});


